import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer id="footer">
      <div className="contact-section">
        <h3>Contact</h3>
        <div className="social-icons">
          <a href="https://www.linkedin.com/in/max-hilsdorf/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          <a href="mailto:max@maxhilsdorf.com"><EmailIcon/></a>
        </div>
      </div>
      <p>Max Hilsdorf, 2025</p>
    </footer>
  );
}

export default Footer;